/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-06 19:30:28
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 12:20:34
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/common.ts
 */
export const suffix = 'salesChannelContentEditorAppearance';
import { generateLinkImg } from '@/src/constrains/DraggableModules/tools';

export enum EnumCollapseId {
  topLeaderBoardBanner = 'topLeaderBoardBanner',
  productDetailsPageTabBarStyle = 'productDetailsPageTabBarStyle',
  flashSaleBarStyle = 'flashSaleBarStyle',
  primaryCallToActionButtonStyle = 'primaryCallToActionButtonStyle',
  secondaryCallToActionButtonStyle = 'secondaryCallToActionButtonStyle',
  remainingStockTextStyle = 'remainingStockTextStyle',
  font = 'font',
  miniProgramNavigationBar = 'miniProgramNavigationBar',
  loadingAnimation = 'loadingAnimation',
  floatingActionButtonStyle = 'floatingActionButtonStyle',
}

export const fixedCollapse = [
  EnumCollapseId.topLeaderBoardBanner,
  EnumCollapseId.productDetailsPageTabBarStyle,
  EnumCollapseId.flashSaleBarStyle,
  EnumCollapseId.primaryCallToActionButtonStyle,
  EnumCollapseId.secondaryCallToActionButtonStyle,
  EnumCollapseId.remainingStockTextStyle,
  EnumCollapseId.font,
  EnumCollapseId.miniProgramNavigationBar,
  EnumCollapseId.loadingAnimation,
  EnumCollapseId.floatingActionButtonStyle,
];

export const generateDefaultFloatingActionButtonStyle = () => {
  return {
    customerServiceBackgroundColor: '#000',
    textColor: '#fff',
    backToTopButtonBackgroundColor: '#fff',
    backToTopIconColor: '#000',
  };
};

export const generateDefaultProductDetailsPageTabBarStyle = () => {
  return {
    soldOutFlag: false,
    iconText: {
      backgroundColor: '#000000',
      textColor: '#ffffff',
      defaultBackgroundColor: '#000000',
      defaultTextColor: '#ffffff',
    },
    addToCart: {
      backgroundColor: '#000000',
      textColor: '#ffffff',
      defaultBackgroundColor: '#000000',
      defaultTextColor: '#ffffff',
    },
    buyNow: {
      backgroundColor: '#BC0025',
      textColor: '#ffffff',
      defaultBackgroundColor: '#BC0025',
      defaultTextColor: '#ffffff',
    },
    soldOut: {
      backgroundColor: '##8C9196',
      textColor: '#ffffff',
      defaultBackgroundColor: '##8C9196',
      defaultTextColor: '#ffffff',
    },
    remindMe: {
      backgroundColor: '#5BBD92',
      textColor: '#ffffff',
      defaultBackgroundColor: '#5BBD92',
      defaultTextColor: '#ffffff',
    },
  };
};
export const generateDefaultFlashSaleBarStyle = () => {
  return {
    saleNow: false,
    comingSoonStatus: {
      backgroundColor: '#5BBD92',
      textColor: '#ffffff',
      defaultBackgroundColor: '#5BBD92',
      defaultTextColor: '#ffffff',
    },
    comingSoonPrice: {
      backgroundColor: '#000000',
      textColor: '#ffffff',
      defaultBackgroundColor: '#000000',
      defaultTextColor: '#ffffff',
    },
    saleNowStatus: {
      backgroundColor: '#BC0025',
      textColor: '#ffffff',
      defaultBackgroundColor: '#BC0025',
      defaultTextColor: '#ffffff',
    },
    saleNowPrice: {
      backgroundColor: '#000000',
      textColor: '#ffffff',
      defaultBackgroundColor: '#000000',
      defaultTextColor: '#ffffff',
    },
    salesNowCountDownTimer: {
      backgroundColor: '#000000',
      textColor: '#ffffff',
      defaultBackgroundColor: '#000000',
      defaultTextColor: '#ffffff',
    },
  };
};

export const generateDefaultPrimaryCallToActionButtonStyle = () => {
  return { backgroundColor: '#000000', textColor: '#ffffff' };
};
export const generateRemainingStockTextStyle = () => {
  return '#000000';
};

export const generateDefaultSecondaryCallToActionButtonStyle = () => {
  return { backgroundColor: '#000000', textColor: '#000000' };
};

export const generateDefaultFont = () => {
  return {
    logographicFont: 'Sans serif',
    enableCustomiseFont: false,
    font: 'Open Sans',
    alphabetFont: 'Sans serif',
    defaultLogographicFont: 'Sans serif',
    defaultAlphabetFont: 'Sans serif',
    defaultFont: 'Open Sans',
  };
};

export const generateDefaultNavigationBar = () => {
  return { backgroundColor: '#000000', fontColor: '#ffffff' };
};

export const generateDefaultTopLeaderBoardBanner = () => {
  return { link: generateLinkImg(1)[0] };
};
